import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

export class CompactView extends Component {
  renderListView() {
    const { zeroState, headerPane, filterPane, listPane } = this.props;
    return (
      <div id="listView">
        { headerPane }
        { filterPane || null }
        { listPane || zeroState }
      </div>
    );
  }

  renderDetailsView() {
    const { zeroState, backButtonLabel, detailsPane } = this.props;
    return (
    <div id="details">
      <button type="button" className="btn btn-primary my-1" onClick={this.props.handleBackButtonClick}>
          <span className="fa-solid fa-chevron-left me-1" />
          <FormattedMessage { ...backButtonLabel } />
      </button>
      { detailsPane || zeroState }
    </div>);
  }

  render() {
    return (
      <div id="content" className="row">
        { this.props.isListView ? this.renderListView() : this.renderDetailsView() }
      </div>
    );
  }
}

CompactView.propTypes = {
  headerPane: PropTypes.object,
  filterPane: PropTypes.object,
  listPane: PropTypes.object,
  detailsPane: PropTypes.object,
  zeroState: PropTypes.object,
  backButtonLabel: PropTypes.object,
  handleBackButtonClick: PropTypes.func,
  isListView: PropTypes.bool,
};
